// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoWrapper_wrapper__WU9lT","buttonWrapper":"InfoWrapper_buttonWrapper__9tH+J","xmark":"InfoWrapper_xmark__tpEpQ"};